export default "__VITE_PUBLIC_ASSET__b7c3915a__"